export default __webpack_public_path__ + "back-8225c33df6c8be9fc365b189c0123804.svg";